module.exports = __webpack_public_path__ + "static/media/more-options.1cf3bf1a.svg";